import { GET_TAB_VALUE_HEADER, GET_TREE_TM, ADD_CATEGORY, ADD_FOLDER, ADD_LIST, GET_LIST_TM, ADD_ATTACHMENT_TM, DELETE_ATTACHMENT_TM, DELETE_ALL_ATTACHMENT_TM, GET_PROJECT_DETAIL_TM, GET_TASK_DETAIL_TM, ADD_TASK, UPDATE_STATUS_TASK, ADD_COMMENT_TM, GET_DASHBOARD_COUNT_TM, PUT_CATEGORY, PUT_LIST, PUT_TASK, DELETE_LIST, DELETE_CATEGORY, GET_PROJECT_CHOICE_TM, DELETE_TASK_TM, GET_MONITORING_TM, GET_ACTION_TASK, DELETE_LIST_TM } from "shared/constants/ActionTypes";

const initialState = {
    tabValue: 'Dashboard',
    list: {
        id: '',
        name: '',
        list: []
    },
    dashboardCount: {
        total_task: 0,
        total_task_overdue: 0,
        total_task_due_today: 0,
        total_task_open: 0,
        total_task_completed: 0,
        total_task_due_this_week: 0
    },
    task: null,
    treeView: [],
    attachments: [],
    projectDetail: null,
    listProject: [],
    monitoring: [],
    actionTask: false
};

const taskManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TAB_VALUE_HEADER:
            return {
                ...state,
                tabValue: action.payload
            }
        case GET_ACTION_TASK:
            return {
                ...state,
                actionTask: action.payload
            }
        case GET_TREE_TM:
            return {
                ...state,
                treeView: action.payload,
            };
        case GET_DASHBOARD_COUNT_TM:
            return {
                ...state,
                dashboardCount: action.payload,
            };
        case ADD_CATEGORY:
            return {
                ...state,
                treeView: action.payload
            };
        case PUT_CATEGORY:
            return {
                ...state,
                treeView: action.payload.treeView,
                projectDetail: action.payload.data,
                list: action.payload.list
            };
        case DELETE_CATEGORY:
            return {
                ...state,
                treeView: action.payload,
            };
        case ADD_FOLDER:
            return {
                ...state,
                treeView: action.payload
            };
        case ADD_ATTACHMENT_TM:
            return {
                ...state,
                attachments: [...state.attachments, action.payload]
            }
        case DELETE_ATTACHMENT_TM:
            return {
                ...state,
                attachments: action.payload
            }
        case DELETE_ALL_ATTACHMENT_TM:
            return {
                ...state,
                attachments: []
            }
        case ADD_LIST:
            return {
                ...state,
                treeView: action.payload
            };
        case PUT_LIST:
            return {
                ...state,
                treeView: action.payload.tree,
                list: action.payload.list,
            };
        case DELETE_LIST:
            return {
                ...state,
                treeView: action.payload,
            };
        case ADD_TASK:
            return {
                ...state,
                list: action.payload
            };
        case PUT_TASK:
            return {
                ...state,
            };
        case UPDATE_STATUS_TASK:
            return {
                ...state,
                list: action.payload,
            };
        case GET_LIST_TM:
            return {
                ...state,
                list: action.payload,
            };
        case GET_PROJECT_DETAIL_TM:
            return {
                ...state,
                projectDetail: action.payload,
            };
        case ADD_COMMENT_TM:
            return {
                ...state,
                task: action.payload
            }
        case GET_TASK_DETAIL_TM:
            return {
                ...state,
                task: action.payload,
            };
        case GET_PROJECT_CHOICE_TM:
            return {
                ...state,
                listProject: action.payload,
            };
        case DELETE_TASK_TM:
            return {
                ...state,
                list: action.payload
            };
        case GET_MONITORING_TM:
            return {
                ...state,
                monitoring: action.payload,
            };
        case DELETE_LIST_TM:
            return {
                ...state,
                list: {
                    ...state.list,
                    list: []
                }
            };
        default:
            return {
                ...state
            }
    }
};

export default taskManagementReducer;